import { EditorSupportViewState } from './schema/EditorSupportViewState';
import { EditorFeatureSupport } from './schema/EditorFeatureSupport';
import { ComposeEditorType } from './schema/ComposeEditorType';

// Map of editor type to feature flags the editor supports.
const editorFeatureSupport: { [key in ComposeEditorType]: EditorFeatureSupport } = {
    [ComposeEditorType.Textarea]: { bottomActionBar: true },
    [ComposeEditorType.RoosterHTML]: { formattingRibbon: true, bottomActionBar: true },
    [ComposeEditorType.RawContentEditableDivHTML]: {},
};

export function getEditorSupport(viewState: EditorSupportViewState): EditorFeatureSupport {
    return editorFeatureSupport[viewState.preferredEditors[viewState.bodyType]];
}
